const React = require('react')
const PropTypes = require('prop-types')
const { Row, Media } = require('reactstrap')
const { useHistory } = require('react-router-dom')
const { useNetworkConfig } = require('@contexts')

require('@styles/pages/home/generalInfo.home/statistics.general.home.css')

const GeneralStatistics = props => {
    const { network } = useNetworkConfig()
    const history = useHistory()

    return (
        <Row>
            <Media className='general-statistics justify-content-between'>
                <Media body={true} className='general-statistics-text-wrapper'>
                    <Media body={true} className={`general-statistics-title`}>
                        {props.title[0]}
                    </Media>
                    <Media
                        body={true}
                        className={props.link && `general-statistics-value ${network.name}-text-color-after`}
                        onClick={props.link ? () => history.push(props.link[0]) : undefined}
                    >
                        {props.value[0]}
                    </Media>
                </Media>
                <Media body={true} className='general-statistics-text-wrapper' style={{ textAlign: 'right' }}>
                    <Media body={true} className='general-statistics-title'>
                        {props.title[1]}
                    </Media>
                    <Media
                        body={true}
                        className={props.link && `general-statistics-value ${network.name}-text-color-after`}
                        onClick={props.link ? () => history.push(props.link[1]) : undefined}
                    >
                        {props.value[1]}
                    </Media>
                </Media>
            </Media>
        </Row>
    )
}

GeneralStatistics.propTypes = {
    title: PropTypes.arrayOf(PropTypes.string).isRequired,
    value: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
    link: PropTypes.arrayOf(PropTypes.string)
}

module.exports = { GeneralStatistics }
